<template>
	<div id="wrop">
		<full-page ref="fullpage" :options="options" v-if="desktop">
			<slot/>
		</full-page>
		<slot v-else/>
	</div>
</template>

<script>
export default {
	name: 'ArticleContainer',
	data() {
		return {
			options: {
				licenseKey: '6E8F5101-0A6A4218-AEC61F0C-EF812275'
			}
		}
	},
	computed: {
		desktop() {
			return window.innerWidth > 900
		}
	}
}
</script>
